import { IReCaptchaProps } from "./ReCaptcha.types";
import React from "react";
import ReCaptchaContainer from "./ReCaptcha.container";

const ReCaptcha: React.FC<IReCaptchaProps> = props => (
  <ReCaptchaContainer {...props} />
);

export default ReCaptcha;
